<ng-sidebar-container>
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
    <div class="sidebar-fix" >
      <div *ngIf="selected!=null">
        <div class="sidebar header-spacing"></div>

        <ngx-project-edit [project]="selected" [customer]="customer" (saved)="onProjectSaved($event)" (cancelled)="onProjectCancelled()"></ngx-project-edit>
        <div class="sidebar header-spacing"></div>
        <div class="sidebar header">
          <div class="row">
            <div class="col-md-12">
              <h1> {{selected.name}}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-sidebar>

  <div ng-sidebar-content>
    <ngx-page-container>

      <h1>My Projects</h1>
      <ngx-search [(value)]="search"></ngx-search>
      <button class="btn btn-primary btn-sm pull-right" (click)="create()">+</button>
      <div style="width:22rem">
        <ngx-form-check *ngIf="me?.admin" name="Show all" [(value)]="showAll" (valueChange)="changeShowAll($event)"></ngx-form-check>
      </div>

      <div style="margin-top:-1em"><pagination-controls (pageChange)="p = $event"></pagination-controls></div>

      <table class="table table-hover" style="margin-top:-1em">
        <thead>
        <tr>
          <th scope="col" style="width: 10%">BU / Equipment / Base&nbsp;Product</th>
          <th scope="col">Customer / Project</th>
          <!--<th scope="col">Project</th>-->
          <!--<th scope="col">Equipment</th>-->
          <th scope="col" class="text-center"> Potential<br>Probability (Share)</th>
          <!--<th scope="col" class="text-right">Probability</th>
          <th scope="col" class="text-right">Share</th>-->
          <!--<th scope="col" colspan="2" class="text-center">Last activity</th>-->
          <th scope="col" style="width: 20%" class="text-center">Last activity<br>Offer / Order</th>
          <!--<th scope="col">Offer date</th>
          <th scope="col">Order Date</th>-->
          <th scope="col">Information</th>
          <th scope="col">Connected Documents</th>
          <th scope="col">Status Type Development</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
                      <!-- [class.table-active]="$any(item) === selected" -->
        <tr *ngFor="let item of filter(search, projects) | paginate: { itemsPerPage: 14, currentPage: p }"
            [class.table-disabled]="isDeactivated($any(item))"
            [class.table-success]="$any(item).showInReport"
            [class.table-inactive]="!$any(item).active"
            (click)="select($any(item))" >
          <td>{{item.businessUnit}}<br><strong>{{item.material}}</strong><br>
            <span *ngIf="$any(item).baseProduct">{{$any(item).baseProduct?.code}} - {{$any(item).baseProduct?.name}} [{{$any(item).baseProduct?.trial}}]</span>
          </td>
          <td><i>{{item.customer}}</i><br><strong>{{item.name}}</strong></td>


          <td class="text-right" *ngIf="item.unit == null || item.unit == ProjectQuantityUnit.Disabled">
            <strong>{{item.potential ? item.potential.toLocaleString('en-US') : ''}} {{$any(item).currency}}</strong><br>
            {{($any(item).probability || 0) * 100}} % ({{($any(item).share || 0) * 100}} %)

          </td>
          <td class="text-right" *ngIf="$any(item).unit != null && (item.unit != ProjectQuantityUnit.Disabled)">
            {{$any(item).quantity.toLocaleString('en-US')}} {{unitOptions[$any(item).unit].name}} ({{$any(item).price.toLocaleString('en-US')}} {{$any(item).currency}})<br><strong>{{($any(item).quantity * $any(item).price).toLocaleString('en-US')}} {{$any(item).currency}}</strong><br>
            {{($any(item).probability || 0) * 100}} % ({{($any(item).share || 0) * 100}} %)
          </td>
          <!--<td class="text-right">{{(item.probability || 0) * 100}} %</td>
          <td class="text-right">{{(item.share || 0) * 100}} %</td>-->
          <td>
            <div class="last" [class.inactive]="!item.lastActivity">
              <i><strong>{{$any(item).lastActivityType}}</strong></i> <span class="pull-right">{{item.lastActivity | date:'MMM dd, yyyy'}}</span><br>
            </div>
            <div class="row">
              <div class="col-6">
                <span class="offer" [class.active]="item.offerDate">OF</span> {{item.offerDate | date:'MMM dd, yyyy'}}<br>
              </div>
              <div class="col-6">
                <span class="order" [class.active]="item.orderDate">OR</span> {{item.orderDate | date:'MMM dd, yyyy'}}
              </div>
            </div>


          </td>

          <!--<td>{{item.offerDate | date:'MMM dd, yyyy'}}</td>
          <td>{{item.orderDate | date:'MMM dd, yyyy'}}</td>-->
          <td><div class="info">{{item.information}}</div></td>
          <td>{{item.connectedDocuments}}</td>
          <td><strong>{{$any(item).status}}</strong><br>{{$any(item).type}}<br>{{item.development ? developmentOptions[item.development].name : ''}}</td>
          <td>
            <button class="btn btn-default btn-sm" style="font-size:larger;padding:0.4rem 0.6rem !important" (click)="load(item)"><i class="ion-edit"></i></button>
          </td>
          <td>
            <button class="btn btn-danger btn-sm" style="font-size:larger;padding:0.4rem 0.6rem !important" (click)="toggleActive(item)"><i [class]="item.active ? 'ion-trash-a' : 'ion-refresh'"></i></button>
          </td>
        </tr>
        </tbody>
      </table>
    </ngx-page-container>
  </div>
</ng-sidebar-container>
